import { type ReactNode, createContext, useContext } from 'react';
import type { AppConfig } from './types';

const ConfigContext = createContext<AppConfig<unknown> | null>(null);

export function ConfigProvider<TExtra>({
  config,
  children,
}: {
  config: AppConfig<TExtra>;
  children: ReactNode;
}) {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig<TExtra = Record<string, never>>(): AppConfig<TExtra> {
  const config = useContext(ConfigContext);

  if (!config) {
    throw new Error('useConfig must be used within a <ConfigProvider>');
  }

  return config as AppConfig<TExtra>;
}
